import {
  validateDay,
  validateMonth,
  validateYear,
} from "$lib/utils/dates/dates";

type ValidateEmail = (email: string) => boolean;
export const validateEmail: ValidateEmail = email => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

type ValidatateDoB = (dob: string) => boolean;
export const validateDoB: ValidatateDoB = dob => {
  if (!dob) return true;
  if (dob === "/") return true; //No dob supplied via the submit function
  const parts: string[] = dob.split("/");
  if (parts.length === 3) {
    const tests: boolean[] = [
      validateDay(parts[0]),
      validateMonth(parts[1]),
      validateYear(parts[2]),
    ];
    return tests.every(t => t);
  } else if (parts.length === 2) {
    const tests: boolean[] = [validateMonth(parts[0]), validateYear(parts[1])];
    return tests.every(t => t);
  } else {
    return false;
  }
};
